<template>
  <div class="box">
    <div class="work">
      <!--路径 -->
      <div class="path">
        <img class="path_img" src="../../../../../assets/images/path.png"/>
        <div class="path_txt">运营管理系统 > 合作伙伴 > 运营报表</div>
      </div>
      <!--查询条件-->
      <div class="condition">
        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label">日期范围:</div>
            <div class="condi_item_cnt_max">
              <el-date-picker
                      v-model="searchCondition.dateRange"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      value="yyyy-MM-dd"
                      range-separator="~"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期" 
                      style="width: 230px">
              </el-date-picker>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">应用类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appType" filterable  clearable  placeholder="请选择应用类型">
                <el-option
                        v-for="appType in Object.keys(appTypeMap)"
                        :key="parseInt(appType)"
                        :label="'(' + appType + ')' + appTypeMap[appType]"
                        :value="parseInt(appType)">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">渠道:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.channelId" filterable clearable placeholder="请选择渠道">
                <el-option
                        v-for="item in channels"
                        :key="item.channel_id"
                        :label="'(' + item.channel_id + ')' + item.channel_name"
                        :value="item.channel_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">渠道号:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.channelSlotId" clearable placeholder="请输入渠道号" />
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放账户:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.issueAccount" clearable placeholder="查询账户信息" />
            </div>
          </div>
        </div>
        <div class="condi_line">
          <div class="condi_item" style="width: 100%">
            <div class="condi_item_label">数据维度:</div>
            <div class="condi_item_cnt" style="width: 100%">
              <el-checkbox-group v-model="searchCondition.dimensions" label="数据维度" @change="onSearch">
                <el-checkbox label="1" name="dimensions" :key="1" style="width:50px;">日期</el-checkbox>
                <el-checkbox label="3" name="dimensions" :key="3" style="width:70px;">应用类型</el-checkbox>
                <el-checkbox label="4" name="dimensions" :key="4" style="width:70px;">渠道</el-checkbox>
                <el-checkbox label="5" name="dimensions" :key="5" style="width:60px;">渠道号</el-checkbox>
                <el-checkbox label="6" name="dimensions" :key="6" style="width:60px;">广告帐户</el-checkbox>
                <template v-if="isShowIncrement">
                  <el-checkbox label="12" name="dimensions" :key="12" style="width:90px;">15分钟增量</el-checkbox>
                  <el-checkbox label="13" name="dimensions" :key="13" style="width:90px;">30分钟增量</el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label"></div>
            <div class="condi_item_cnt_max">
              <el-button type="primary" @click="onSearch" style="width:100px;">查询</el-button>
            </div>
          </div>
        </div>
      </div>

      <!--数据列表-->
      <div class="datalist">
        <div class="dtlst_top">
          <div class="dtlst_title">合伙伙伴运营报表</div>
        </div>
        <div class="dtlst_table">
          <el-table
            :data="pageTable.tableData"
            :row-class-name="reportRowClass"
            :stripe="true"
          >

            <el-table-column key="report_date" prop="report_date" label="日期" width="120px" v-if="searchCondition.dimensions.indexOf('1')!=-1">
              <template slot-scope="scope">{{scope.row.report_date}}</template>
            </el-table-column>
            
            <el-table-column key="app_type" prop="app_type" label="应用类型" width="120px" v-if="searchCondition.dimensions.indexOf('3')!=-1">
              <template slot-scope="scope">({{scope.row.app_type}}){{appTypeMap[scope.row.app_type]}}</template>
            </el-table-column>

            <el-table-column key="channel_id" prop="channel_id" width="150px" label="渠道" v-if="searchCondition.dimensions.indexOf('4')!=-1">
              <template slot-scope="scope">({{scope.row.channel_id}}){{scope.row.channel_id && channels.find(item => item.channel_id == scope.row.channel_id).channel_name}}</template>
            </el-table-column>
            
            <el-table-column key="channel_slot_id" prop="channel_slot_id" width="80px" label="渠道号" v-if="searchCondition.dimensions.indexOf('5')!=-1">
              <template slot-scope="scope">{{scope.row.channel_slot_id}}</template>
            </el-table-column>

            <el-table-column key="score" prop="score" label="渠道质量" width="100px" align="right">
              <template slot-scope="scope">
                <el-tag style="width:80px;" type="danger" v-if="scope.row.lunion_pos_income==null || scope.row.lunion_pos_income==0 || scope.row.ad_cost==null || scope.row.ad_cost==0 ||(parseFloat(scope.row.lunion_pos_income * 100 / scope.row.ad_cost - 10).toFixed(2) < 95)">
                  {{scope.row.lunion_pos_income==null || scope.row.lunion_pos_income==0 || scope.row.ad_cost==null || scope.row.ad_cost==0 ? '-' : (parseInt(scope.row.lunion_pos_income * 100 / scope.row.ad_cost - 10) >= 0 ? parseFloat(scope.row.lunion_pos_income * 100 / scope.row.ad_cost - 10).toFixed(2) : 0)}}
                </el-tag>
                <el-tag style="width:80px;" type="normal" v-else>
                  {{scope.row.lunion_pos_income==null || scope.row.lunion_pos_income==0 || scope.row.ad_cost==null || scope.row.ad_cost==0 ? '-' : (parseInt(scope.row.lunion_pos_income * 100 / scope.row.ad_cost - 10) >= 0 ? parseFloat(scope.row.lunion_pos_income * 100 / scope.row.ad_cost - 10).toFixed(2) : 0)}}
                </el-tag>
              </template>
            </el-table-column>

            <template v-if="isShowIncrement">
              <!-- 计算规则 roi*100-10 保留两位小数  低于90红色-->
              <el-table-column key="snap15_roi" v-if="searchCondition.dimensions.includes('12')" prop="snap15_roi" label="增量渠道质量(15)" width="140px" align="right">
                <template slot-scope="scope">
                  <el-tag style="width:80px;" type="danger" v-if="parseFloat(scope.row.snap15_roi* 100- 10).toFixed(2) < 95">
                    {{scope.row.snap15_roi | filtersRoi}}
                  </el-tag>
                  <el-tag style="width:80px;" type="normal" v-if="parseFloat(scope.row.snap15_roi* 100- 10).toFixed(2) >= 95">
                    {{scope.row.snap15_roi | filtersRoi}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column key="snap30_roi" v-if="searchCondition.dimensions.includes('13')" prop="snap30_roi" label="增量渠道质量(30)" width="140px" align="right">
                <template slot-scope="scope">
                  <el-tag style="width:80px;" type="danger" v-if="parseFloat(scope.row.snap30_roi* 100- 10).toFixed(2) < 95">
                    {{scope.row.snap30_roi | filtersRoi}}
                  </el-tag>
                  <el-tag style="width:80px;" type="normal" v-if="parseFloat(scope.row.snap30_roi* 100- 10).toFixed(2) >= 95">
                    {{scope.row.snap30_roi | filtersRoi}}
                  </el-tag>
                </template>
              </el-table-column>
            </template>

            <el-table-column key="owner_id,owner_name" prop="owner_id" width="300px" label="推广帐户" v-if="searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">
                {{scope.row.ad_new==1 ? '[新]' : ''}}({{scope.row.owner_id}}){{scope.row.owner_name}}
              </template>
            </el-table-column>
            
            <el-table-column key="ad_balance" prop="ad_balance" align="right" width="100px" label="帐户余额" v-if="searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">{{!scope.row.ad_balance ? '' : parseFloat(scope.row.ad_balance * 1.0 / 1000000.0).toFixed(2)}}</template>
            </el-table-column>
            <el-table-column key="ad_daily_budget" prop="ad_daily_budget" align="right" width="120px" label="帐户日预算" v-if="searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">{{!scope.row.ad_daily_budget ? '' : parseFloat(scope.row.ad_daily_budget * 1.0 / 1000000.0).toFixed(0)}}</template>
            </el-table-column>
            
            <el-table-column key="ad_cost" prop="ad_cost" label="推广花费" width="120px" align="right">
              <template slot-scope="scope">{{parseFloat(scope.row.ad_cost * 1.0 / 1000000.0 ).toFixed(2)}}</template>
            </el-table-column>

            <template v-if="isShowIncrement">
              <el-table-column key="snap15_cost" v-if="searchCondition.dimensions.includes('12')" prop="snap15_cost" label="增量消耗(15)" width="110px" align="right">
                <template slot-scope="scope">
                  {{scope.row.snap15_cost ? parseFloat(scope.row.snap15_cost * 1.0 / 1000000.0).toFixed(2) : '-'}}
                </template>
              </el-table-column>
              <el-table-column key="snap30_cost" v-if="searchCondition.dimensions.includes('13')" prop="snap30_cost" label="增量消耗(30)" width="110px" align="right">
                <template slot-scope="scope">
                  {{scope.row.snap30_cost ? parseFloat(scope.row.snap30_cost * 1.0 / 1000000.0).toFixed(2) : '-'}}
                </template>
              </el-table-column>
            </template>

            <el-table-column key="ad_impression" prop="ad_impression" label="推广曝光成本" width="120px" align="right">
              <template slot-scope="scope">{{!scope.row.ad_impression ? '0.00' : parseFloat(scope.row.ad_cost * 1.0 / scope.row.ad_impression / 1000.0 ).toFixed(2)}}</template>
            </el-table-column>
            <el-table-column key="ad_click" prop="ad_click" label="推广点击成本" width="120px" align="right">
              <template slot-scope="scope">{{!scope.row.ad_click ? '0.00' : parseFloat(scope.row.ad_cost * 1.0 / scope.row.ad_click / 1000000.0 ).toFixed(2)}}</template>
            </el-table-column>
            
            <el-table-column key="app_uv,ad_cost" prop="app_uv,ad_cost" label="引流单人成本" width="120px" align="right">
              <template slot-scope="scope">{{scope.row.app_uv==null || scope.row.app_uv==0 ? '-' : parseFloat(scope.row.ad_cost / (scope.row.app_uv * 1000000.0)).toFixed(4)}}</template>
            </el-table-column>

            <el-table-column key="app_effect_count,app_effect_total" prop="app_effect_count,app_effect_total" label="效果数据回传比例" width="160px" align="right">
              <template slot-scope="scope">{{scope.row.app_effect_total==0 ? '-' : parseFloat(scope.row.app_effect_count * 100.0 / scope.row.app_effect_total).toFixed(2) + '%'}}</template>
            </el-table-column>
            <el-table-column key="estimate_roi" v-if="isShowWarning" prop="estimate_roi" label="全天亏损预警" width="110px" align="center">
              <template slot-scope="scope">
                <img v-if="scope.row.estimate_roi<1 && scope.row.estimate_roi" class="roi_warning" src="../../../../../assets/images/warning.png"/>
              </template>
            </el-table-column>

            <el-table-column key="dtlst_operation" label="操作" width="100px">
              <template slot-scope="scope">
                <div class="dtlst_operation">
                  <el-button type="success" size="small" @click="adAccount(scope.row.channel_slot_id,scope.row.app_type,'2')" v-if="scope.row.app_type == '61' || scope.row.app_type == '62' || searchCondition.appType =='61' || searchCondition.appType =='62'">广告账户</el-button>
                </div>
              </template>
            </el-table-column>

          </el-table>

          <!-- 广告账户弹窗 -->
          <el-dialog title="广告账户" 
            :visible.sync="dialogAdAccount"
            v-loading="dialogLoading" 
            element-loading-text="提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.3)"
            style="min-height: 100px;"
            width="85%"
            :close-on-click-modal="false">
            <div class="account-info-box">
              <div class="account-info-item account-info-txt">账户余额(元)：{{ acCountBalance }}</div>
              <div class="account-info-item account-info-txt">今日消耗(元)：{{ adConsumption }}</div>
              <div class="account-info-item">
                <div class="account-info-txt editable-field" @dblclick="startEditingDailyCap">账户日预算(元)：
                  <span v-if="isEditingDailyCap">
                    {{ editingDailyCapValue == '-1' || editingDailyCapValue == null ? '不限' : editingDailyCapValue ? parseFloat(editingDailyCapValue).toFixed(2) : editingDailyCapValue }}
                  </span>
                </div>
                <!-- 修改账户日预算弹窗 -->
                <div v-if="!isEditingDailyCap" class="dailycap_mask">
                  <div class="dailycap">
                    <div class="dailycap_header">修改账户日预算</div>
                    <div class="dailycap_body">
                      <div class="dailycap_radio_row">
                        <label class="dailycap_radio">
                          <el-radio v-model="radio" label="1" @change="handleRadioChange">不限</el-radio>
                        </label>
                        <label class="dailycap_radio">
                          <el-radio v-model="radio" label="2" @change="handleRadioChange">自定义</el-radio>
                        </label>
                      </div>

                      <div class="dailycap_input_row" v-if="showBudgetModal">
                        <input
                          v-model.number="editingDailyCapValue" 
                          autofocus
                          type="number">
                        <div class="input_suffix">元/天</div>
                      </div>
                    </div>

                    <div class="dailycap_footer">
                      <button class="btn-plain" @click="closeBudgetModal">取 消</button>
                      <button class="btn-green" @click="confirmBudget">确 定</button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!-- 操作按钮 -->
            <div class="account-info-box">
              <el-button type="primary" @click="batchToggleSwitch(0)">批量开</el-button>
              <el-button type="primary" @click="batchToggleSwitch(1)">批量关</el-button>
              <el-button type="primary" @click="batchUpdatePrice">批量修改出价</el-button>
              <div style="margin-left: 10px;">
                <el-select v-model="adGroupValue" @change="handleAdGroup" placeholder="筛选广告组">
                  <el-option
                    v-for="item in adGroupOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>

            <el-table :data="gridData" @selection-change="handleSelectionChange">
              <el-table-column type="selection"></el-table-column>
              <el-table-column label="广告计划" width="220">
                <template slot-scope="scope">
                  {{ "(" + scope.row.planId + ")" }} - {{ scope.row.planName }}
                </template>
              </el-table-column>
              <el-table-column label="广告组" width="220">
                <template slot-scope="scope">
                  {{ "(" + scope.row.adGroupId + ")" }} - {{ scope.row.adGroupName }}
                </template>
              </el-table-column>
              <el-table-column label="开关" width="100" header-align="right" align="right">
                <template slot-scope="scope">
                  <el-switch 
                    v-model="scope.row.switch"
                    :active-value="0"
                    :inactive-value="1" 
                    active-color="#13ce66" 
                    inactive-color="#848484" 
                    @change="handleSwitchChange(scope)"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column property="ocpcPrice" label="出价" width="300" header-align="center" align="center">
                <template slot-scope="scope" style="display: flex; align-items: center; gap: 8px;">
                  <!-- 非编辑状态：显示「分」转「元」（保留2位小数） -->
                  <span style="width: 100px; text-align: center;"
                    v-if="!scope.row.isEditingPrice" 
                    @dblclick="handlePriceDbClick(scope)">
                    {{scope.row.bidType == 1 ? 'ROI系数' : '价格'}} : {{ scope.row.bidType == 1  ? parseFloat(scope.row.roiFactor / 100).toFixed(2) : parseFloat(scope.row.ocpcPrice / 100).toFixed(2) }} 
                    <!-- 直接用分计算，避免类型问题 -->
                  </span>
                  <!-- 编辑状态：输入框（动态ref，避免冲突） -->
                  <el-input 
                    v-else
                    v-model="scope.row.ocpcPriceEdit"
                    size="mini"
                    @input="handlePriceInput(scope)"
                    style="width: 140px; margin-right: 10px;"
                    :ref="`priceInput-${scope.$index}`"
                    autofocus
                  ></el-input>
                  <!-- 确认按钮：点击才触发修改 -->
                  <el-button v-if="scope.row.isEditingPrice" plain size="mini" type="primary" @click="scope.row.isEditingPrice = false">取消</el-button>
                  <el-button v-if="scope.row.isEditingPrice" plain size="mini" type="primary" @click="handlePriceConfirm(scope)">确认</el-button>
                </template>
              </el-table-column>
              <!-- 其他列保持不变 -->
              <el-table-column property="cost" label="消耗" width="80" header-align="right" align="right">
                <template slot-scope="scope">
                  {{ !scope.row.cost ? '-' : parseFloat(scope.row.cost / 100).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column property="adEffectCount" label="效果数" width="80" header-align="right" align="right"></el-table-column>
              <el-table-column label="效果成本" width="80" header-align="right" align="right">
                <template slot-scope="scope">
                  {{ !scope.row.cost || scope.row.cost === 0 || !scope.row.adEffectCount || scope.row.adEffectCount === 0 ? '-' : parseFloat(scope.row.cost / 100 / scope.row.adEffectCount).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column label="点击成本" width="80" header-align="right" align="right">
                <template slot-scope="scope">
                  {{ !scope.row.cost || scope.row.cost === 0 || scope.row.click === 0 ? '-' : parseFloat(scope.row.cost / 100 / scope.row.click).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column property="clickRate" label="点击率" width="80" header-align="right" align="right">
                <template slot-scope="scope">
                  {{ !scope.row.clickRate || scope.row.clickRate === 0 ? '-' : `${parseFloat(scope.row.clickRate).toFixed(2)}%` }}
                </template>
              </el-table-column>
              <el-table-column property="clickRate" label="快应用地址" width="140" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" v-if="platform == 'oppo' && !scope.row.rpkDeepLink" plain @click="getrpkDeepLink(scope)">获取地址</el-button>
                  <el-tooltip v-if="platform == 'oppo' && scope.row.rpkDeepLink" :content="scope.row.rpkDeepLink || '-'" placement="top">
                    <div class="text-ellipsis" >{{ scope.row.rpkDeepLink ? scope.row.rpkDeepLink : '-' }}</div>
                  </el-tooltip>
                  <el-tooltip v-if="platform == 'vivo'" :content="scope.row.rpkDeepLink || '-'" placement="top">
                    <div class="text-ellipsis">{{ !scope.row.rpkDeepLink ? '-' : scope.row.rpkDeepLink }}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>

          <div class="dtlst_pagination">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="pageTable.pageIndex"
              :page-size="pageTable.pageSize"
              :page-sizes="[100, 200, 500, 1000]" 
              :page-count="pageTable.pageCount"
              :total="pageTable.recordTotalCount"
              @current-change="changeCurrPage"
              @size-change="changePageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      showBudgetModal: false,
      radio: '1',
      adGroupOptions: [{
        value: '1',
        label: '所有广告组',
      }, {
        value: '2',
        label: '仅有消耗广告组',
      }],
      adGroupValue: '2',                // 初始默认选中2
      prevValue: '2',                   // 记录上一次选中值，用于取消时回退
      prevDailyCap: null,               // 记录上一次选中值，用于取消时回退
      isSelectDisabled: false,          // 控制整个选择器是否禁用
      editingDailyCapValue: null,       // 账户封顶
      acCountBalance: null,             // 账户余额
      adConsumption: null,              // 今日消耗
      isEditingDailyCap: true,
      dialogLoading: false,
      channelSlotIdAdAccount: null,
      selectedRows: [],           // 存储多选的行数据
      dialogAdAccount: false,     // 广告账户弹窗开关
      gridData: [],

      // 操作员对象
      operator: null,

      // 分页表格
      pageTable: {
        pageIndex: 1,         // 当前页索引
        pageSize: 500,        // 本页显示数量
        pageCount: 1,         // 分页总数
        recordTotalCount: 0,  // 记录
        tableData: [],        // 应用列表数据
      },

      // 搜索的参数
      searchCondition: {
        appId: null,          // 应用
        appType: null,        // 应用类型
        dateRange: null,      // 日期范围
        channelId: null,      // 渠道ID
        channelSlotId: null,  // 渠道位置ID
        issuePlatform: null,  // 投放平台
        issueFlow: null,      // 投放平台流量
        issueAccount: null,   // 投放帐户
        measureId: null,      //测评ID
        dimensions: ["1","5","6","12","13"],    // 数据维度
      },

      apps: [],               // 应用
      channels: [],           // 渠道
      
      // 投放平台和流量列表
      issuePlatforms: [],
      issueFlows: [],
      
      // 报表类型映射表
      reportTypeMap: {
        'app': "应用",
        'ad': "广告",
        'union': "联盟",
        'baidu': "百度"
      },

      // 应用类型
      appTypeMap: {
         5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },

      // 当前投放平台（广告账户专用）
      platform: 'oppo',
    };
  },
  watch: {
    isShowIncrement: {
      handler: function(val, oldVal) {
        if (val!=oldVal) { // 重置值
          if (!val) {
            this.searchCondition.dimensions = this.searchCondition.dimensions.filter(v => v!='12' && v!='13')
          } else { // 默认值
            !this.searchCondition.dimensions.includes('12')&&this.searchCondition.dimensions.push('12')
            !this.searchCondition.dimensions.includes('13')&&this.searchCondition.dimensions.push('13') 
          }
        }
      },
      deep: true
    }
  },
  filters: {
    filtersRoi(value) { // 增量渠道质量处理
      if (!value) { // 如果值为空，返回'-'
        return  '-'
      } else if (parseFloat(value* 100- 10).toFixed(2) <=0) { // 如果值小于等于0，返回'0.00'
        return '0.00'
      } else { // 否则返回计算后的结果
        return parseFloat(value* 100- 10).toFixed(2)
      }
    } 
  },
  computed: {
    // 是否展示增量数据
    isShowIncrement() {
      try {
        const today = moment(new Date()).format('YYYY-MM-DD')
        const beginDate = moment(this.searchCondition.dateRange[0]).format('YYYY-MM-DD')
        const endDate = moment(this.searchCondition.dateRange[1]).format('YYYY-MM-DD')
        return beginDate ===today && endDate === today && this.searchCondition.dimensions.includes('1')&& this.searchCondition.dimensions.includes('5')
      } catch (e) {
        return false
      }
    },
    // 是否展示全天亏损预警列
    isShowWarning() {
      try {
        const today = moment(new Date()).format('YYYY-MM-DD')
        const beginDate= moment(this.searchCondition.dateRange[0]).format('YYYY-MM-DD');
        const endDate= moment(this.searchCondition.dateRange[1]).format('YYYY-MM-DD');
        return today === beginDate && today === endDate && this.searchCondition.dimensions.includes('5')
      } catch (e) {
        return false;
      }
    }
  },
  created() {
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 初始化数据
    this.getInitDate();
    this.initApps();
    this.initChannels();
    this.initIssuePlatforms();
    this.loadIssueFlows();
    // 获取用数据
    this.getPartnerQuickMarketRpt(1);
  },

  methods: {
    // 获取oppo广告组的deeplink链接
    async getrpkDeepLink(scope) {
      const row = scope.row;
      try {
        let res = await this.$api.apiGetdeeplink({channelSlotId:this.channelSlotIdAdAccount,operatorId: this.operator.operatorId,adGroupId:row.adGroupId});
        if(res && res.result == 1 && res.content) {
          this.$set(row, 'rpkDeepLink', res.content.deeplink);
          this.$message('获取成功',"success");
        }else {
          this.$message('获取失败，请重试',"error");
        }
      } catch (error) {
        this.$message('获取失败，请重试',"error");
      }
      
    },

    // 取消修改日预算
    closeBudgetModal() {
      this.isEditingDailyCap = true;
      this.$message('已取消','info');
      this.editingDailyCapValue = this.prevDailyCap;
    },

    // 确认修改日预算
    confirmBudget() {
      // 确认操作：调用API更新
      try {
        this.dialogLoading = true;
        if(this.radio == 1) {
          this.gApiUpdbudget(this.channelSlotIdAdAccount,this.operator.operatorId,'-1');
          this.prevDailyCap = null;
          this.editingDailyCapValue = null;
        }else {
          this.gApiUpdbudget(this.channelSlotIdAdAccount,this.operator.operatorId,this.editingDailyCapValue);
          this.prevDailyCap = this.editingDailyCapValue;
        }
        this.dialogLoading = false;
        this.isEditingDailyCap = true;
        this.$message('更新成功',"success");
      } catch (error) {
        this.$message('更新失败，请重试',"error");
        // 接口失败时回退选中值
        this.editingDailyCapValue = this.prevDailyCap;
      }
    },

    // 展示自定义编辑框
    handleRadioChange() {
      if (this.radio == "2") {
        // 选择自定义时，显示输入框
        this.showBudgetModal = true;
        // 如果当前值为不限，清空输入框等待用户输入
        if (this.editingDailyCapValue == null || this.editingDailyCapValue == '-1' || this.editingDailyCapValue === '') {
          this.editingDailyCapValue = '';
        }
      } else {
        // 选择不限时，隐藏输入框
        this.showBudgetModal = false;
      }
    },
    
    // 获取当日消耗
    async gApiGetadcost(channelSlotId,platform) {
      // 当日消耗
      let res = await this.$api.apiGetadcost({channelSlotId,platform,operatorId: this.operator.operatorId});
      if(res && res.result==1 && res.content) {
        this.adConsumption = res.content.adCost > 0 ? res.content.adCost*1.0 / 100 : 0
        this.acCountBalance = res.content.adBalance > 0 ? res.content.adBalance*1.0 / 100 : 0
        this.prevDailyCap = res.content.adDailyBudget && res.content.adDailyBudget > 0 ? res.content.adDailyBudget*1.0 / 100 : res.content.adDailyBudget == 0 ? 0 : res.content.adDailyBudget;
        this.editingDailyCapValue = res.content.adDailyBudget && res.content.adDailyBudget > 0 ? res.content.adDailyBudget*1.0 / 100 : res.content.adDailyBudget == 0 ? 0 : res.content.adDailyBudget;
        this.radio = this.editingDailyCapValue == null || this.editingDailyCapValue == '-1' ? "1" : "2";
      }
    },

    // 设置当日消耗
    async gApiUpdbudget(channelSlotId,operatorId,accDayBudget) {
      if (accDayBudget == '-1') {
        accDayBudget = '-1';
      } else if (accDayBudget && accDayBudget != 'null') {
        accDayBudget = parseFloat(accDayBudget) * 100;
      }
      await this.$api.apiUpdbudget({channelSlotId,platform:this.platform,operatorId,accDayBudget});
    },

    // 筛选广告组
    handleAdGroup(e) {
      // 弹出确认提示框
      this.$confirm('确定要切换广告组吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 确认操作：调用API更新
        try {
          this.dialogLoading = true;
          // 1. 调用接口（示例）
          await this.adAccount(this.channelSlotIdAdAccount,this.platform,e);
          // 2. 记录当前值为上一次值
          this.prevValue = e;
          this.dialogLoading = false;
          this.$message('更新成功',"success");
        } catch (error) {
          this.$message('更新失败，请重试',"error");
          // 接口失败时回退选中值
          this.adGroupValue = this.prevValue;
        }
      }).catch(() => {
        // 取消操作：回退到之前的选中值
        this.adGroupValue = this.prevValue;
        this.$message('已取消操作',"info");
      });
      
    },

    // 编辑账户封顶
    startEditingDailyCap() {
      this.isEditingDailyCap = false;
      // 判断当前值：null、'-1'、空字符串都表示不限
      const isUnlimited = this.editingDailyCapValue == null 
        || this.editingDailyCapValue == '-1' 
        || this.editingDailyCapValue == ''
        || this.editingDailyCapValue == undefined;
      
      if (isUnlimited) {
        this.showBudgetModal = false;
        this.radio = "1"; // 不限
      } else {
        this.showBudgetModal = true;
        this.radio = "2"; // 自定义
      }
    },

    // 确认修改广告组开关（优化：等待接口返回后再更新本地状态）
    async updateAdSwitch(channelSlotId, adGroupId, onoff) {
      this.dialogLoading = true;
      try {
        let res = await this.$api.updateSwitch({ channelSlotId, platform: this.platform, adGroupIds: adGroupId, onoff, operatorId: this.operator.operatorId });
        if(res && res.result == 1) {
          this.$message("成功修改广告组开关","success");
          // 接口成功后再更新本地状态（避免接口失败但本地已变）
          if (Array.isArray(this.gridData)) {
            // 统一处理 adGroupId：转换为字符串数组
            const adGroupIdArray = typeof adGroupId === 'string' 
              ? adGroupId.split(',').map(id => String(id.trim()))
              : [String(adGroupId)];
            
            this.gridData.forEach(row => {
              if (adGroupIdArray.includes(String(row.adGroupId))) {
                row.switch = onoff;
              }
            });
          }
        }else {
          this.$message(`更新开关失败：${res.message || "网络错误"}`, "error");
        }
      } catch (err) {
        console.log(err);
        this.$message(`更新开关失败：${err.message || "网络错误"}`, "error");
      } finally {
        this.dialogLoading = false;
      }
    },

    // 确认修改广告组转化出价（优化：参数校验）
    async updateAdAccount(channelSlotId, bidType, adGroupId, price) {
      if (typeof adGroupId === 'number' && !isNaN(adGroupId)) {
        adGroupId =  String(adGroupId); // 数字类型 → 转为字符串
      }
      if (!price || isNaN(price)) {
        this.$message("无效的价格参数",'error');
        return;
      }
      const priceInCent = Math.round(Number(price) * 100); // 转为分（避免浮点数精度问题）
      this.dialogLoading = true;
      try {
        let res = await this.$api.updateAdPrice({ channelSlotId,platform:this.platform, bidType, adGroupIds: adGroupId, price: priceInCent, operatorId: this.operator.operatorId});
        if(res && res.result == 1) {
          this.$message("修改出价成功","success");
          // 接口成功后更新本地状态
          if (Array.isArray(this.gridData)) {
            this.gridData.forEach(row => {
              if (adGroupId.includes(row.adGroupId)) {
                if (bidType == 1) {
                  row.roiFactor = priceInCent; // ROI系数类型，更新 roiFactor
                } else {
                  row.ocpcPrice = priceInCent; // 价格类型，更新 ocpcPrice
                }
              }
            });
          }
        }else {
          this.$message(`更新出价失败：${res.message || "网络错误"}`,"error");
        }
      } catch (err) {
        console.log('更新出价失败：err----',err);
        this.$message(`更新出价失败：${err.message || "网络错误"}`,"error");
      } finally {
        this.dialogLoading = false;
      }
    },

    // 多选变化时，更新选中行数据
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },

    handleSwitchChange(scope) {
      this.updateAdSwitch(this.channelSlotIdAdAccount, scope.row.adGroupId, scope.row.switch);
    },

    // 批量修改开关状态
    batchToggleSwitch(evt) {
      if (this.selectedRows.length === 0) {
        this.$message('请先选择要操作的行',"warning");
        return;
      }
      const adGroupIds = this.selectedRows.map(row => row.adGroupId);
      // evt: 0=开启, 1=关闭
      const actionText = evt === 0 ? '开启' : '关闭';
      this.$confirm(`确定要${actionText}选中的广告组吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateAdSwitch(this.channelSlotIdAdAccount, adGroupIds.join(','), evt);
      }).catch(() => {
        // 取消操作不做处理
      });
    },
    
    // 批量修改出价（优化：等待接口返回后更新）
    batchUpdatePrice() {
      if (this.selectedRows.length === 0) {
        this.$message('请先选择要操作的行',"warning");
        return;
      }
      // 检查bidType是否一致
      const firstBidType = this.selectedRows[0]?.bidType;
      const isConsistent = this.selectedRows.every(row => row.bidType == firstBidType);
      if (!isConsistent) {
        this.$message('出价类型不一致，请重新选择！',"warning");
        return;
      }
      // 保存当前出价类型
      const consistentBidType = firstBidType;
      this.$prompt('请输入要批量设置的出价', '提示', {
        inputType: 'number',
        inputPlaceholder: '输入出价（最多两位小数）',
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: '请输入有效的出价（最多两位小数）'
      }).then(({ value }) => {
        const price = Number(value).toFixed(2); // 元
        const adGroupIds = this.selectedRows.map(row => row.adGroupId);
        this.updateAdAccount(this.channelSlotIdAdAccount,consistentBidType, adGroupIds.join(','), price);
      }).catch(() => {
        this.$message('已取消批量修改出价','info');
      });
    },

    // 双击进入编辑状态（优化：用单独字段存储编辑值，避免污染原始数据）
    handlePriceDbClick(scope) {
      const row = scope.row;
      row.isEditingPrice = true;
      // 原始价格是「分」，转为「元」用于编辑（保留2位小数）
      row.ocpcPriceEdit = row.bidType == 1  ? (row.roiFactor / 100).toFixed(2) : (row.ocpcPrice / 100).toFixed(2);
      // 聚焦当前行的input（动态ref）
      this.$nextTick(() => {
        const inputRef = this.$refs[`priceInput-${scope.$index}`];
        if (inputRef) {
          inputRef.focus();
          // 选中所有文本，方便用户直接输入新值
          inputRef.select();
        }
      });
    },

    // 实时过滤价格输入（修复：支持正常的小数点输入）
    handlePriceInput(scope) {
      const row = scope.row;
      let value = String(row.ocpcPriceEdit || '');

      // 基础过滤：只保留数字和小数点
      value = value.replace(/[^\d.]/g, '');
      
      // 处理开头的小数点
      if (value.startsWith('.')) {
        value = '0' + value;
      }
  
      // 处理多个小数点
      const dotIndex = value.indexOf('.');
      if (dotIndex !== -1) {
        const beforeDot = value.substring(0, dotIndex);
        const afterDot = value.substring(dotIndex + 1);
        value = beforeDot + '.' + afterDot.replace(/\./g, '');
      }
      
      // 限制小数位数
      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2);
        }
      }

      // 将处理后的值赋回给编辑字段
      row.ocpcPriceEdit = value;
    },

    // 出价确认（修复：正确处理字符串到数字的转换）
    handlePriceConfirm(scope) {
      const row = scope.row;
      
      // 空值/无效值校验
      if (row.ocpcPriceEdit === '' || row.ocpcPriceEdit === '.') {
        this.$message('请输入有效的价格',"error");
        return; 
      }
      
      // 转换为数字进行验证
      const priceValue = parseFloat(row.ocpcPriceEdit);
      if (isNaN(priceValue) || priceValue < 0) {
        this.$message('请输入有效的非负数字',"error");
        return; 
      }
      
      // 格式化价格（元，保留2位小数）
      const priceInYuan = priceValue.toFixed(2);
      
      // 关闭编辑状态
      row.isEditingPrice = false;
      
      // 调用更新接口（传入元，内部转为分） 
      this.updateAdAccount(this.channelSlotIdAdAccount, row.bidType, row.adGroupId, priceInYuan);
    },

    // 广告账户详情
    async adAccount(channelSlotId,platform,groupSelector) {
      this.platform = platform;
      // 保存当前投放平台
      if(platform && platform == '62' || this.searchCondition.appType == '62') {
        this.platform = 'vivo';
      }
      if(platform && platform == '61' || this.searchCondition.appType == '61') {
        this.platform = 'oppo';
      }
      this.channelSlotIdAdAccount = channelSlotId;
      this.adGroupValue = groupSelector;
      // 当日消耗
      this.gApiGetadcost(channelSlotId,this.platform)
      if (!channelSlotId) {
        this.$message("请选择具体渠道位置","warning");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: '.box'
      });
      try {
        const res = await this.$api.apiLuckyStatAdAccount({ channelSlotId,platform:this.platform,operatorId:this.operator.operatorId,groupSelector});
        if (res.result === 1 && Array.isArray(res.content)) {
          // 初始化编辑状态和价格（确保ocpcPrice为数字类型）
          this.gridData = res.content.map(item => ({
            ...item,
            isEditingPrice: false,
            ocpcPrice: Number(item.ocpcPrice) || 0, // 确保是数字（分）
            switch: item.switch != null ? Number(item.switch) : 1,// 确保是数字
            ocpcPriceEdit: '' // 编辑用的临时字段
          }));
          this.dialogAdAccount = true;
        } else {
          this.$message("获取数据失败","error");
        }
      } catch (err) {
        this.$message(`加载失败：${err.message || "网络错误"}`,"error");
      } finally {
        loading.close();
      }
    },

    // 表格行样式
    reportRowClass({row}) {
      if(row.ad_cost != null && row.ad_cost != 0) {
        if(row.lunion_pos_income / row.ad_cost < 2) {
          return 'table_row_danger';
        }
      }
      return '';
    },

    async initApps() {
      // 清空当前应用
      this.apps = [];
      // 调用接口
      let res = await this.$api.apiPartnerCommonApps({
        operatorId: this.operator.operatorId
      });
      // 保存结果
      this.apps = res.content;
    },

    async initChannels() {
      // 清空当前渠道
      this.channels = [];
      // 调用接口
      let res = await this.$api.apiPartnerCommonChannels({
        operatorId: this.operator.operatorId
      });
      // 保存结果
      this.channels = res.content;
    },
    
    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = [];
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },
    
    // 加载发布平台流量类型
    async loadIssueFlows() {
      // 清空当前流量类型
      this.searchCondition.issueFlow = null;
      this.issueFlows = [];
      // 调用接口
      let params = {};
      if(this.searchCondition.issuePlatform!=null && this.searchCondition.issuePlatform!='') {
        params['issuePlatformTag'] = this.searchCondition.issuePlatform;
      }
      let res = await this.$api.apiCommonIssueFlows(params);
      // 保存结果
      this.issueFlows = res.content;
    },

    async getPartnerQuickMarketRpt(mode) {
      // 如果日期为空，不能查询
      if(this.searchCondition.dateRange==null) {
        this.$message("报表查询必须选择日期范围","warning");
        return;
      }
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      let paramsSerial = '';
      params['pageIndex'] = this.pageTable.pageIndex;
      params['pageSize'] = this.pageTable.pageSize;
      if(this.operator && this.operator.operatorId) {
        params['operatorId'] = this.operator.operatorId;
        paramsSerial += '&operatorId=' + this.operator.operatorId;
      }
      if(this.searchCondition.appId!=null) {
        params['appId'] = this.searchCondition.appId;
        paramsSerial += '&appId=' + this.searchCondition.appId;
      }
      if(this.searchCondition.appType!=null) {
        params['appType'] = this.searchCondition.appType;
        paramsSerial += '&appType=' + this.searchCondition.appType;
      }
      if(this.searchCondition.dateRange!=null && this.searchCondition.dateRange[0]!=null) {
        params['beginDate'] = moment(this.searchCondition.dateRange[0]).format('YYYY-MM-DD');
        paramsSerial += '&beginDate=' + params['beginDate'];
      }
      if(this.searchCondition.dateRange!=null && this.searchCondition.dateRange[1]!=null) {
        params['endDate'] = moment(this.searchCondition.dateRange[1]).format('YYYY-MM-DD');
        paramsSerial += '&endDate=' + params['endDate'];
      }
      if(this.searchCondition.channelId!=null) {
        params['channelId'] = this.searchCondition.channelId;
        paramsSerial += '&channelId=' + params['channelId'];
      }
      if(this.searchCondition.channelSlotId!=null) {
        params['channelSlotId'] = this.searchCondition.channelSlotId;
        paramsSerial += '&channelSlotId=' + params['channelSlotId'];
      }
      if(this.searchCondition.issuePlatform!=null && this.searchCondition.issuePlatform!='') {
        params['issuePlatform'] = this.searchCondition.issuePlatform;
        paramsSerial += '&issuePlatform=' + params['issuePlatform'];
      }
      if(this.searchCondition.issueFlow!=null && this.searchCondition.issueFlow!='') {
        params['issueFlow'] = this.searchCondition.issueFlow;
        paramsSerial += '&issueFlow=' + params['issueFlow'];
      }
      if(this.searchCondition.issueAccount!=null && this.searchCondition.issueAccount!='') {
        params['issueAccount'] = this.searchCondition.issueAccount;
        paramsSerial += '&issueAccount=' + params['issueAccount'];
      }
      if(this.searchCondition.measureId!=null) {
        params['measureId'] = this.searchCondition.measureId;
        paramsSerial += '&measureId=' + params['measureId'];
      }
      if(this.searchCondition.dimensions!=null && this.searchCondition.dimensions.length>0) {
        params['dimensions'] = ',' + this.searchCondition.dimensions.join(',') + ',';
        paramsSerial += '&dimensions=' + params['dimensions'];
      }
      // 基于不同模式分别处理
      if(mode==undefined || mode==1) {
        // 调用接口
        let res = await this.$api.apiPartnerQuickMarketList(params);
        if(res.result !== 1) {
          this.$message("加载合作伙伴运营报表失败","warning");
          // 加载结束
          loading.close();
          return;
        }
        // 获取分页数据
        this.pageTable.pageIndex = res.content.pageIndex;
        this.pageTable.pageSize = res.content.pageSize;
        this.pageTable.pageCount = res.content.pageCount;
        this.pageTable.recordTotalCount = res.content.recordTotalCount;
        // 应用数据存进data
        this.pageTable.tableData = res.content.records;
      } else {
        console.log(paramsSerial);
      }
      
      // 加载结束
      loading.close();
    },
    
    // 搜索
    async onSearch() {
      // 先清空原有数据
      this.tableData = [];
      // 查询数据
      this.getPartnerQuickMarketRpt(1);
    },

    // 变更当前页面
    async changeCurrPage(currPage) {
      this.pageTable.pageIndex = currPage;
      this.getPartnerQuickMarketRpt(1);
    },

    // 变更页面大小
    async changePageSize(pageSize) {
      this.pageTable.pageSize = pageSize;
      this.pageTable.pageIndex = 1;
      this.getPartnerQuickMarketRpt(1);
    },
    
    getInitDate(){
      if(this.searchCondition.dateRange!=null 
          && this.searchCondition.dateRange!=undefined 
          && this.searchCondition.dateRange.length>0) {
        return;
      }
      
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();

      let befDate = new Date();
      befDate=befDate.setDate(befDate.getDate());
      befDate=new Date(befDate)
      let byear = befDate.getFullYear();
      let bmonth = befDate.getMonth() + 1;
      let bday = befDate.getDate();

      // 默认日期赋值
      this.searchCondition.dateRange = [new Date(byear + ', ' + bmonth + ', ' + bday),new Date(year + ', ' + month + ', ' + day)];

      // 今日
      this.today = moment().format("YYYY-MM-DD");
      // 昨日
      this.yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
      // 今日小时
      this.hour = nowDate.getHours();
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.work {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right:5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.condition {
  margin: 10px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  flex-direction: row column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_line {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row column;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_item {
  margin-left: 30px;
  width: 260px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_max {
  margin-left: 30px;
  width: 330px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_label {
  text-align: left;
  width: 100px;
  font-size: 16px;
}
.condi_item_cnt {
  width: 160px;
  font-size: 16px;
}
.condi_item_cnt_max {
  width: 230px;
  font-size: 16px;
}
.condi_item_cnt .el-input {
  width: 160px;
}
.condi_item_cnt_max .el-input {
  width: 230px;
}
.condi_item_cnt .el-select {
  width: 160px;
}
.condi_item_cnt_max .el-select {
  width: 230px;
}
.condi_item_cnt .el-button {
  width: 160px;
}
.condi_item_cnt_max .el-date-picker {
  width: 230px;
}
.datalist {
  margin: 0px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  border-radius: 9px;
  overflow: auto;
  background: #fff;
}
.datalist .el-table {
  margin: 0 auto;
  width: 96%;
}
.dtlst_top {
  margin: 10px 10px 10px 15px;
  width: 96%;
  height: 25px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  align-items: center;
  background: #fff;
}
.dtlst_title {
  color: black;
  font-size: 1rem;
  font-weight: 500;
  width: 300px;
  height: 25px;
  text-align: left;
}
.dtlst_btn {
  height: 20px;
  width: calc(100% - 100px);
  text-align: right;
}
.dtlst_btn .el-button {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  color: white;
  background: #1890ff;
  height: 25px;
  width: 100px;
}
.dtlst_table {
  width: 98%;
  height: auto;
}
.dtlst_operation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dtlst_pagination {
  margin: 6px 0px;
  width: 96%;
  height: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.table_row_warning {
  background: rgb(226, 150, 8);
}
.table_row_danger {
  color: red;
  background: rgb(241, 3, 3);
}
.roi_warning{
  height: 15px;
  width: 15px;
}
// 日预算
.account-info-box {
  height: 40px;
  display: flex;
  margin-bottom: 20px;
}
.account-info-item {
  box-sizing: border-box;
  padding: 0 10px;
  background: #f2f4f5;
  margin-right: 50px;
  line-height: 40px;
  height: 40px;
  display: flex;
}
.account-info-txt {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.dailycap_mask {
  position: fixed; 
  inset: 0; 
  z-index: 999;
  background: rgba(0,0,0,.45);
  display: flex; 
  align-items: center; 
  justify-content: center;
}
.dailycap {
  width: 680px; 
  background: #fff; 
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,.08);
}
.dailycap_header {
  padding: 20px 24px; 
  font-size: 22px; 
  font-weight: 700; 
  color: #111;
  border-bottom: 1px solid #f0f0f0;
}
.dailycap_body {
  padding: 24px;
}
.dailycap_radio_row { 
  display: flex; 
  gap: 40px; 
  align-items: center; 
  margin-bottom: 18px; 
}
.dailycap_radio { 
  display: inline-flex; 
  align-items: center; 
  gap: 12px; 
  font-size: 22px; 
  color: #333; 
  cursor: pointer; 
  user-select: none; 
}
.dailycap_radio input { 
  display: none; 
}
.dailycap_radio input:checked + .radio-dot { 
  border-color: #22c79a;
}
.dailycap_radio input:checked + .radio-dot::after { 
  background: #22c79a; 
}
.dailycap_radio.custom { 
  color: #22c79a; 
}
.dailycap_input_row {
  display: flex; 
  align-items: stretch; 
  border: 1px solid #e5e7eb; 
  border-radius: 10px; 
  overflow: hidden; 
}
.dailycap_input_row input { 
  flex: 1; 
  border: none; 
  outline: none; 
  height: 54px; 
  padding: 0 16px; 
  font-size: 20px; 
}
.dailycap_input_row .input_suffix { 
  width: 120px; 
  background: #f5f7fa; 
  color: #666; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  font-size: 18px; 
}
.dailycap_input_row.disabled { 
  opacity: .5; 
}
.dailycap_footer { 
  display: flex; 
  justify-content: flex-end; 
  gap: 16px; 
  padding: 20px 24px 24px; 
}
.btn-plain { 
  height: 44px; 
  min-width: 120px; 
  padding: 0 18px; 
  border-radius: 10px; 
  border: 1px solid #d0e9df; 
  background: #fff; 
  color: #22c79a; 
  font-size: 18px; 
  cursor: pointer; 
}
.btn-green { 
  height: 44px; 
  min-width: 140px; 
  padding: 0 22px; 
  border-radius: 10px; 
  border: none; 
  background: #22c79a; 
  color: #fff; 
  font-size: 18px; 
  cursor: pointer; 
}
.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>